"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M15 1H1c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1zm1 4H0V3h16v2zm-3-2h-2V1h2v2z"];
//# sourceMappingURL=modal-filled.js.map